import React from "react";

import { STRING } from "@constants";

import { SizesSideBarProps } from "./types";
import { UnitCategoryUpdate } from "@types";

import { SidebarContainers } from "@components";
import { UnitCategoryForm } from "./UnitCategoryForm";

export function UnitCategorySideBar({
  show,
  onClose,
  editValues,
}: SizesSideBarProps) {
  return (
    <SidebarContainers
      show={show}
      onClose={onClose}
      title={
        editValues
          ? STRING.UNIT_CATEGORY_FORM.TITLE_UPDATE
          : STRING.UNIT_CATEGORY_FORM.TITLE_CREATE
      }
    >
      <UnitCategoryForm
        onClose={onClose}
        editValues={editValues as UnitCategoryUpdate}
      />
    </SidebarContainers>
  );
}
